import { useConditionValueFieldPath } from '../fieldPaths';
import { useQueryErrorStateContext } from '../../../contexts/queryErrorState';

export const useHasConditionValueWarning = () => {
  const fieldPath = useConditionValueFieldPath();
  const { getHasWarningFromFieldPath } = useQueryErrorStateContext();
  const warningFromFieldPath = getHasWarningFromFieldPath(fieldPath);

  return warningFromFieldPath;
};
